module.exports = __webpack_public_path__ + "view/img/test.8f4ba08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test.png
// module id = 2FlR
// module chunks = 1